// src/pages/Home.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import Card from '../components/Card';
import Contact from '../components/Contact';

function Home() {
  return (
    <>
      <Hero />
        <Card />
      <Helmet>
        <title>Psikolog Gülfem Dikici Çelikay | Ana Sayfa</title>
        <meta
          name="description"
          content="Psikolog Gülfem Dikici Çelikay ile bireysel terapi ve online danışmanlık hizmetleri. Hemen randevu alın."
        />
        <meta property="og:title" content="Psikolog Gülfem Dikici Çelikay | Ana Sayfa" />
        <meta property="og:description" content="Bireysel terapi, çift terapisi, çocuk terapisi, şema terapi, grup terapisi, workshop, atölye ve daha fazlası." />
      </Helmet>
      <Contact></Contact>
    
  </>  
  );
}

export default Home;
